import React, { useEffect, useState } from "react";

const SalesTaxCalc = ({ salesTaxState, state_tax, avg_local_tax, max_local_tax, combined_tax }) => {
   const [price, setPrice] = useState("");
   const [priceType, setPriceType] = useState("beforeTax");
   const [numGoods, setNumGoods] = useState("1");
   const [stateTaxRate, setStateTaxRate] = useState(`${state_tax}`);
   const [avgLocalTaxRate, setAvgLocalTaxRate] = useState(`${avg_local_tax}`);
   const [maxLocalTaxRate, setMaxLocalTaxRate] = useState(`${max_local_tax}`);
   const [combinedTaxRate, setCombinedTaxRate] = useState(`${combined_tax}`);
   const [totalPrice, setTotalPrice] = useState({
      state_price: "",
      avg_local_price: "",
      max_local_price: "",
      combined_price: "",
   });

   

   function handleCalculateTotalPrice() {
      const inputPrice = parseFloat(price);
      const state_tax_rate = parseFloat(stateTaxRate);
      const avg_local_tax_rate = parseFloat(avgLocalTaxRate);
      const max_local_tax_rate = parseFloat(maxLocalTaxRate);
      const combined_tax_rate = parseFloat(combinedTaxRate);
      const inputNumGoods = parseInt(numGoods);

      if (isNaN(inputPrice) || isNaN(state_tax_rate) || isNaN(inputNumGoods)) {
         setTotalPrice((prev) => ({ ...prev, state_price: "Enter Price" }));
         return;
      }

      let total_price = 0;
      let totalStatePrice = 0;
      let totalLocalPrice = 0;
      let totalMaxPrice = 0;
      let totalCombinedPrice = 0;
      if (priceType === "beforeTax") {
         totalStatePrice = inputPrice * (1 + state_tax_rate / 100) * inputNumGoods;
         totalLocalPrice = inputPrice * (1 + avg_local_tax_rate / 100) * inputNumGoods;
         totalMaxPrice = inputPrice * (1 + max_local_tax_rate / 100) * inputNumGoods;
         totalCombinedPrice = inputPrice * (1 + combined_tax_rate / 100) * inputNumGoods;
      } else {
         total_price = inputPrice * inputNumGoods;
         totalStatePrice = total_price / (1 + state_tax_rate / 100);
         totalLocalPrice = total_price / (1 + avg_local_tax_rate / 100);
         totalMaxPrice = total_price / (1 + max_local_tax_rate / 100);
         totalCombinedPrice = total_price / (1 + combined_tax_rate / 100);
      }

      setTotalPrice((prev) => ({
         ...prev,
         state_price: totalStatePrice.toFixed(2),
         avg_local_price: totalLocalPrice.toFixed(2),
         max_local_price: totalMaxPrice.toFixed(2),
         combined_price: totalCombinedPrice.toFixed(2),
      }));
   }

   useEffect(()=>{
      setStateTaxRate(state_tax)
      setAvgLocalTaxRate(avg_local_tax)
      setMaxLocalTaxRate(max_local_tax)
      setCombinedTaxRate(combined_tax)
      // console.log("Hello")
   },[state_tax, avg_local_tax, max_local_tax, combined_tax])
   
   return (
      <div className="bg-white w-full xl:w-[1000px] py-10 px-[10px] md:px-[30px] rounded-lg drop-shadow-2xl mx-auto h-fit">
         <div className="flex flex-col gap-[20px] items-start xl:flex-row">
            <div className="max-w-[100%] mx-auto xl:w-[50%] bg-white py-[30px] md:py-[30px] grid place-items-center h-full xl:h-[600px]">
               <h3 className="text-gray-500 font-medium text-[20px] border-b-2 pb-[5px] mb-[20px] text-left">
                  Calculate Sales Tax {salesTaxState ? "for " + salesTaxState : ""}
               </h3>
               <div className="flex flex-col gap-[15px] justify-center items-start w-full">
                  <div className="flex w-[100%] justify-between items-center gap-[10px]">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px]"
                     >
                        Price
                     </label>
                     <div className="flex flex-col xl:flex-row gap-[5px]">
                        <input
                           type="text"
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                           value={price}
                           onChange={(e) => setPrice(e.target.value)}
                        />
                        <select
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                           id=""
                           name=""
                           required
                           value={priceType}
                           onChange={(e) => setPriceType(e.target.value)}
                        >
                           <option value="beforeTax">Before Tax</option>
                           <option value="afterTax">After Tax</option>
                        </select>
                     </div>

                  </div>
                  <div className="flex w-[100%] justify-between items-center gap-[10px]">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px]"
                     >
                        No. Of Goods
                     </label>
                     <input
                        type="text"
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                        value={numGoods}
                        onChange={(e) => {
                           setNumGoods(e.target.value);
                        }}
                     />
                  </div>
               </div>
               <div className="w-full h-[1px] bg-gray-200 my-[20px]"></div>
               <div className="flex flex-col gap-[10px] justify-between items-center w-full">
                  <div className="flex w-[100%] justify-between items-center gap-[10px] mx-auto">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px] text-left"
                     >
                        State Tax Rate
                     </label>
                     <input
                        type="text"
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                        value={stateTaxRate}
                        onChange={(e) => {
                           setStateTaxRate(e.target.value);
                        }}
                     />
                  </div>
                  <div className="flex w-[100%] justify-between items-center gap-[10px] mx-auto">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px] text-left"
                     >
                        Avg. Local Tax Rate
                     </label>
                     <input
                        type="text"
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                        value={avgLocalTaxRate}
                        onChange={(e) => {
                           setAvgLocalTaxRate(e.target.value);
                        }}
                     />
                  </div>
                  {/* <div className="flex w-[100%] justify-between items-center gap-[10px] mx-auto">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px] text-left"
                     >
                        Max Local Tax Rate
                     </label>
                     <input
                        type="text"
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                        value={maxLocalTaxRate}
                        onChange={(e) => {
                           setMaxLocalTaxRate(e.target.value);
                        }}
                     />
                  </div> */}
                  <div className="flex w-[100%] justify-between items-center gap-[10px] mx-auto">
                     <label
                        htmlFor=""
                        className="text-gray-500 font-medium text-[20px] text-left"
                     >
                        Combined Rate
                     </label>
                     <input
                        type="text"
                        className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                        value={combinedTaxRate}
                        onChange={(e) => {
                           setCombinedTaxRate(e.target.value);
                        }}
                     />
                  </div>
               </div>

               <button onClick={handleCalculateTotalPrice} className="w-full mt-[30px] h-[50px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl">
                  Calculate
               </button>
            </div>
            <div className="w-[100%] xl:w-[50%] h-full xl:h-[600px] flex flex-col items-center justify-center gap-[20px] pb-[20px] xl:pb-[0px] rounded-lg bg-slate-200">
               <h3 className="text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500">
                  Price {priceType === "beforeTax" ? "After Tax" : "Before Tax"}
               </h3>
               <div className="w-full text-gray-500 font-medium flex flex-col gap-[10px]">
                  <div className=" flex items-center gap-[30px] justify-around text-[20px] mx-[15px]">
                     <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">
                        Tax Category
                     </div>
                     <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">
                        Total Cost
                     </div>
                  </div>
                  <div className=" flex items-center justify-around text-[18px] text-gray-400">
                     <div className="w-[50%] text-center">State Tax</div>
                     <div className="w-[50%] text-center">${totalPrice.state_price}</div>
                  </div>
                  <div className=" flex items-center justify-around text-[18px] text-gray-400">
                     <div className="w-[50%] text-center">Avg. Local Tax</div>
                     <div className="w-[50%] text-center">${totalPrice.avg_local_price}</div>
                  </div>
                  {/* <div className=" flex items-center justify-around text-[18px] text-gray-400">
                     <div className="w-[50%] text-center">Max. Local Tax</div>
                     <div className="w-[50%] text-center">${totalPrice.max_local_price}</div>
                  </div> */}
                  <div className=" flex items-center justify-around text-[18px] text-gray-400">
                     <div className="w-[50%] text-center">Combined Tax</div>
                     <div className="w-[50%] text-center">${totalPrice.combined_price}</div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default SalesTaxCalc;
